import { useEffect, useState } from "react";
import { getReconnectEpoch, subscribeToReconnect } from "@/lib/session";

/**
 * A number that changes whenever the app recovers its connection.
 *
 * Put it in the dependency array of any effect that loads data:
 *
 *   const reconnectKey = useReconnect();
 *   useEffect(() => { load(); }, [reconnectKey]);
 *
 * Without this, recovering the session fixed authentication but not the
 * screen — every list fetches once on mount, so after an outage the app was
 * connected and empty at the same time, and only a browser refresh (which
 * re-runs every mount effect) appeared to fix it.
 */
export function useReconnect(): number {
  const [epoch, setEpoch] = useState(getReconnectEpoch);
  useEffect(() => subscribeToReconnect(setEpoch), []);
  return epoch;
}
